import { render } from "./Logout.vue?vue&type=template&id=6b9bfee0&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=6b9bfee0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9bfee0"]])

export default __exports__